import React from 'react';
import ModuleRoute from 'holocron-module-route';
import { Route } from '@americanexpress/one-app-router';
import ErrorMessage from './components/ErrorMessage';
import AccountEnrollment from './components/AccountEnrollment';

const childRoutes = () => [
  <ModuleRoute key="wrapper" moduleName="axp-page-wrapper" header="one-commercial-payments-enrollment-header" footer="one-commercial-payments-enrollment-footer" containerClassName="dls-gray-02-bg">
    <ModuleRoute key="/card-selector" path="/card-selector" moduleName="one-commercial-payments-enrollment-card-selector" />
    <ModuleRoute key="/terms-and-conditions" path="/terms-and-conditions" moduleName="one-commercial-payments-enrollment-terms-and-conditions" />
    <ModuleRoute key="/confirmation" path="/confirmation" moduleName="one-commercial-payments-enrollment-confirmation" />
    <Route path="/account-enrollment" components={AccountEnrollment} />
    <Route path="*" component={ErrorMessage} />
  </ModuleRoute>,
];

export default childRoutes;
